import LegacyTrackingService from "../tracking_service_legacy";
import TrackingService from "./tracking_service";
import BrandTile from "./brandTile";

export default class PromoBrandShopPromo {

    constructor(container) {
        this.container = container;
        this.promoType = this._getPromoType(container);
        this.featureOrder = this._getFeatureOrder(container);
        this.featureIndex = this._getFeatureIndex(container);
        this.items = container.querySelectorAll('.promo_brandshoppromo--image-container a');
        const brandTileDoms = container.querySelectorAll('.promo_brandshoppromo--tile');
        this.brandTiles = [].map.call(brandTileDoms, brandTileDom => new BrandTile(brandTileDom))
        this.sourceUrls = this._getSourceUrls();
        this.filledSlots = this.items.length;
        this.legacyTrackingService = new LegacyTrackingService();
        this.trackingService = new TrackingService();

        this.trackView();

        [].map.call(this.items, (item, index) => {
            item.addEventListener("click", this.trackClick(this.brandTiles[index], index), false);
        })
    }

    trackClick(brandTile, index) {
        const self = this;
        return function () {
            const legacyTrackingData = self.legacyTrackingService.getClickTrackingPayload(self.promoType, this.getAttribute("href"), self.featureOrder, self.featureIndex, self.filledSlots, parseInt(this.getAttribute("data-item-index")) + 1, 'manual', "click", null, null);
            self.trackingService.sendClickTrackingEvent(legacyTrackingData, self.featureOrder, self.featureIndex, brandTile, index + 1, self.filledSlots, self.promoType);
        }
    }

    trackView() {
        const destinationUrls = [].map.call(this.items, item => item.getAttribute('href'));
        this.trackingService.sendViewTracking(this.featureOrder, this.featureIndex, this.promoType, this.brandTiles);
        this.legacyTrackingService.sendViewTrackingEvent(this.promoType, destinationUrls, null, this.featureOrder, this.featureIndex, this.filledSlots, this.sourceUrls);
    }

    _getPromoType() {
        return this.container.getAttribute("data-promo-type");
    }

    _getFeatureOrder() {
        return parseInt(this.container.parentElement.getAttribute('data-feature-order'), 0);
    }

    _getFeatureIndex(container) {
        return parseInt(container.getAttribute('data-feature-index'), 0);
    }

    _getSourceUrls() {
        const shoppromoImageContainer = this.container.querySelectorAll('.promo_brandshoppromo--image-container');
        return [].map.call(shoppromoImageContainer, () => 'manual');
    }
}
